module.exports = __webpack_public_path__ + "img/34_online-gambling.4c8a96f7.jpg";